import React from "react";
import Flex from "@vahak/core-ui/dist/layout/Flex";

// Icons
import ProfileVerifyTag from "@vahak/core/dist/icons/up_verified_profile.svg";
import AadhaarVerified from "@vahak/core/dist/icons/aadhar_verified.svg";
import GstVerified from "@vahak/core/dist/icons/GST_verified.svg";
import BankVerified from "@vahak/core/dist/icons/Bank_Verified.svg";
import VahakMember from "@vahak/core/dist/icons/VahakMember.svg";

interface ProfileVerificationLevelPropsType {
    isBankVerified: boolean;
    isAadhaarVerified?: boolean;
    isGSTVerified?: boolean;
    isMember?: boolean;
}
const ProfileVerificationLevel = ({
    isBankVerified,
    isAadhaarVerified,
    isGSTVerified,
    isMember
}: ProfileVerificationLevelPropsType) => {
    return (
        <Flex gap={5} alignItems="center">
            {isGSTVerified && isAadhaarVerified && !isMember ? (
                <span title="aadhaar and gst verified">
                    <ProfileVerifyTag />
                </span>
            ) : isGSTVerified && !isAadhaarVerified ? (
                <span title="only gst verified">
                    <GstVerified />
                </span>
            ) : !isGSTVerified && isAadhaarVerified ? (
                <span title="only aadhaar verified">
                    <AadhaarVerified />
                </span>
            ) : null}
            {isBankVerified ? (
                <span title="bank details available">
                    <BankVerified />
                </span>
            ) : null}
            {isMember ? (
                <span title="Vahak Membership taken">
                    <VahakMember />
                </span>
            ) : null}
        </Flex>
    );
};

export default ProfileVerificationLevel;
